export default ({
  username = undefined,
  password = undefined
} = {}) => ({
  username,
  password
})